import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getProfileData, getTeamdata, updateProfileData, URLApi } from "../../../services/api_function";
import toast from "react-hot-toast";
import axios from "axios";

function UserProfile() {
    const [apiData, setApiData] = useState([]);
    const [recordStatus, setRecordStatus] = useState("Loading...");
    const [showModal, setShowModal] = useState(false);
    const location = useLocation();
    const [action, setAction] = useState('');
    const userGet = new URLSearchParams(location.search).get("user");
    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await getProfileData(userGet);
                setApiData(result?.data);
                if (!result?.data?.data?.[0]) {
                    setRecordStatus("No Record");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);
    const [updatedData, setUpdatedData] = useState({
        fullName: "",
        email: "",
        phone: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUpdatedData({
            ...updatedData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const userDetails = localStorage.getItem("adminToken");
        const token = userDetails;
        try {
            const updatedFields = {};

            if (updatedData.fullName && updatedData.fullName !== apiData.fullName) {
                updatedFields.fullName = updatedData.fullName;
            }
            if (updatedData.email && updatedData.email !== apiData.email) {
                updatedFields.email = updatedData.email;
            }
            if (updatedData.phone && updatedData.phone !== apiData.phone) {
                updatedFields.phone = updatedData.phone;
            }

            if (Object.keys(updatedFields).length > 0) {
                const response = await updateProfileData(userGet, updatedFields, token);
                if (response.status == 200) {
                    toast.success("Profile Update")
                }
                setShowModal(false);
            } else {
                setShowModal(false);
            }

        } catch (error) {
            console.error("Error updating profile:", error);
        }
    };


    const approveKycData = async (actionType) => {
        try {
            const userDetails = localStorage.getItem("adminToken");
            const token = userDetails;
            const response = await axios.post(URLApi + '/approve-Kyc', {
                user: userGet,
                action: actionType,
            },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });

            if (response.status == 200) {
                toast.success(`KYC ${actionType}d successfully!`);
            } else {
                toast.error(`Failed to ${actionType} KYC`);
            }
        } catch (error) {
            console.error('Error while performing KYC action:', error);
            alert('There was an error processing the request.');
        }
    }
    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                {apiData?.kyc_Type !== "Manual" && (
                    <div className="col-lg-6 col-md-8">
                        <div className="card border-light rounded-3 shadow-lg">
                            {/* Card Body */}
                            <div className="card-body text-center">
                                {/* Profile Image */}
                                <div className="mb-4">
                                    <img
                                        src={apiData?.profileImage || "https://via.placeholder.com/150"}
                                        alt="Profile"
                                        className="border border-3 border-primary rounded-circle mb-3"
                                        width="150"
                                        height="150"
                                    />
                                </div>
                                {/* User Information */}
                                <h3 className="fw-bold mb-2">{apiData?.fullName || "John Doe"}</h3>
                                <h5 className="text-muted mb-4">{apiData?.userId || "User ID"}</h5>

                                <ul className="list-unstyled">
                                    <li className="mb-3"><strong>Phone:</strong> {apiData?.phone || "N/A"}</li>
                                    <li className="mb-3"><strong>Email:</strong> {apiData?.email || "N/A"}</li>
                                    <li className="mb-3"><strong>DOB:</strong> {new Date(Number(apiData?.dob)).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}</li>
                                    <li className="mb-3"><strong>Gender:</strong> {apiData?.gender || "N/A"}</li>
                                    <li className="mb-3"><strong>Care of:</strong> {apiData?.careof || "N/A"}</li>
                                    <li className="mb-3"><strong>Country:</strong> {apiData?.country || "N/A"}</li>
                                    <li className="mb-3"><strong>State:</strong> {apiData?.state || "N/A"}</li>
                                    <li className="mb-3"><strong>City:</strong> {apiData?.city || "N/A"}</li>
                                    <li className="mb-3"><strong>Pincode:</strong> {apiData?.pincode || "N/A"}</li>
                                    <li className="mb-3"><strong>Address:</strong> {apiData?.address || "N/A"}</li>
                                    <li className="mb-3"><strong>Kyc:</strong> {apiData?.createdAt ? new Date(apiData.createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }) : "N/A"}</li>
                                </ul>
                            </div>
                            <button className="btn btn-primary mt-4" onClick={() => setShowModal(true)} style={{
                                backgroundColor: '#007bff',
                                color: '#fff',
                                borderColor: '#007bff',
                                borderRadius: '5px',
                                padding: '10px 20px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                display: 'inline-block'
                            }}>
                                Edit Profile
                            </button>
                        </div>
                    </div>
                )}

                {apiData?.kyc_Type == "Manual" && (
                    <div className="col-lg-6 col-md-8">
                        <div className="card border-light rounded-3 shadow-lg">

                            <div className="card-body text-center">

                                <div className="mb-4">
                                    <img
                                        src={apiData?.profileImage ? `https://api.metherium.io${apiData.profileImage}` : "https://via.placeholder.com/150"}
                                        alt="Profile"
                                        className="border border-3 border-primary rounded-circle mb-3"
                                        width="150"
                                        height="150"
                                    />
                                </div>
                                <h3 className="fw-bold mb-2">{apiData?.fullName || "John Doe"}</h3>
                                <h5 className="text-muted mb-4">{apiData?.userId || "User ID"}</h5>

                                <ul className="list-unstyled">
                                    <li className="mb-3"><strong>Phone:</strong> {apiData?.phone || "N/A"}</li>
                                    <li className="mb-3"><strong>Email:</strong> {apiData?.email || "N/A"}</li>

                                    <li className="mb-3"><strong>Gender:</strong> {apiData?.gender || "N/A"}</li>

                                    <li className="mb-3"><strong>Country:</strong> {apiData?.nationality || "N/A"}</li>
                                    <li className="mb-3"><strong>State:</strong> {apiData?.state || "N/A"}</li>
                                    <li className="mb-3"><strong>City:</strong> {apiData?.city || "N/A"}</li>
                                    <li className="mb-3"><strong>Pincode:</strong> {apiData?.pincode || "N/A"}</li>
                                    <li className="mb-3"><strong>Address 1:</strong> {apiData?.address || "N/A"}</li>
                                    <li className="mb-3"><strong>Address 2:</strong> {apiData?.address_2 || ""}</li>
                                    <li className="mb-3"><strong>Kyc:</strong> {apiData?.createdAt ? new Date(apiData.createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }) : "N/A"}</li>
                                </ul>
                                <div className="shadow-sm mb-10" style={{ borderRadius: "15px" }}>
                                    <img
                                        src={apiData?.profileImage ? `https://api.metherium.io${apiData.profileImage}` : "https://via.placeholder.com/150"}
                                        alt="Profile"
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            objectFit: 'cover',
                                            borderRadius: "15px"
                                        }}
                                    />
                                </div>
                                <div className="mt-3">
                                    <button className="btn btn-success me-2" style={{
                                        padding: '8px 15px',
                                        fontWeight: 'bold',
                                        borderRadius: '5px'
                                    }}
                                        onClick={() => approveKycData('approve')}
                                    >
                                        Approve
                                    </button>
                                    <button className="btn btn-danger ms-2" style={{
                                        padding: '8px 15px',
                                        fontWeight: 'bold',
                                        borderRadius: '5px'
                                    }}
                                        onClick={() => approveKycData('reject')}
                                    >
                                        Reject
                                    </button>
                                </div>
                            </div>

                            <button className="btn btn-primary mt-4" onClick={() => setShowModal(true)} style={{
                                backgroundColor: '#007bff',
                                color: '#fff',
                                borderColor: '#007bff',
                                borderRadius: '5px',
                                padding: '10px 20px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                display: 'inline-block'
                            }}>
                                Edit Profile
                            </button>

                        </div>
                    </div>
                )}

                {showModal && (
                    <div className="modal show" tabIndex="-1" style={{ display: "block" }} aria-labelledby="editProfileModal" aria-hidden="true">
                        <div className="modal-dialog">
                            <div className="modal-content" style={{ width: "500px", left: "847px", top: "70px" }}>
                                <div className="modal-header">
                                    <h5 className="modal-title" id="editProfileModal">Edit Profile</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="modal-body">
                                        <div className="mb-3">
                                            <label htmlFor="fullName" className="form-label">Full Name</label>
                                            <input
                                                type="text"
                                                id="fullName"
                                                name="fullName"
                                                className="form-control"
                                                value={updatedData.fullName}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="email" className="form-label">Email</label>
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                className="form-control"
                                                value={updatedData.email}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="phone" className="form-label">Phone</label>
                                            <input
                                                type="text"
                                                id="phone"
                                                name="phone"
                                                className="form-control"
                                                value={updatedData.phone}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                                            Close
                                        </button>
                                        <button type="submit" className="btn btn-primary" style={{
                                            backgroundColor: '#007bff',
                                            color: '#fff',
                                            borderColor: '#007bff',
                                            borderRadius: '5px',
                                            padding: '10px 20px',
                                            fontWeight: 'bold',
                                            textAlign: 'center',
                                            display: 'inline-block'
                                        }}>
                                            Update Profile
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default UserProfile;